import React from "react";
import {makeProductsPage} from "src/core/pages/productsPagesFactory";
import routes from "src/core/common/routes";
import ProductListSchema from "src/core/seo/components/ProductListSchema";
import {
  saveHome,
  getHomeServerSideProps,
  getHomeStaticProps,
} from "src/server/preloader/homePage";
import * as Sentry from "@sentry/nextjs";
import {getTags} from "src/server/preloader/utils";

const BasePage = makeProductsPage(() => ({pathname: routes.home}));

export default function ({dataProps, serverProps, ...props}) {
  const home = serverProps && serverProps.home ? serverProps.home : dataProps.home;
  saveHome(home);

  return (
    <>
      <ProductListSchema path={"login/"} />
      <BasePage dataProps={dataProps} serverProps={serverProps} {...props} />
    </>
  );
}

export async function ssr_getServerSideProps(context) {
  Sentry.setTags(getTags("getServerSideProps", context));

  return getHomeServerSideProps(context);
}

export async function isr_getStaticProps(context) {
  Sentry.setTags(getTags("getStaticProps", context));

  return getHomeStaticProps(context);
}
export async function isr_getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}
